export const FETCH_COUNTRY_ERROR = "FETCH_COUNTRY_ERROR";
export const RECEIVE_COUNTRY = "RECEIVE_COUNTRY";

export function receiveCountry(data, premierAvailable) {
  return {
    type: RECEIVE_COUNTRY,
    countryData: data.subscriptionOptions && data.subscriptionOptions[0],
    premierAvailable,
  };
}

export function fetchError(err) {
  return {
    type: FETCH_COUNTRY_ERROR,
    apiError: err,
  };
}
